export { GetType } from './getType'
